import { Command } from 'commander';
import { RedmineConfigService } from '../../services/redmine-config.service.js';
import { checkConnectivity } from '../../services/redmine-connectivity.service.js';

interface CheckOptions {
    config?: string;
    json?: boolean;
}

/**
 * Create redmine check command
 */
export function createRedmineCheckCommand(): Command {
    const cmd = new Command('check')
        .description('Check Redmine connectivity')
        .option('-c, --config <path>', 'Config file path', 'redmine.config.yaml')
        .option('--json', 'Output as JSON')
        .action(async (options: CheckOptions) => {
            await handleRedmineCheck(options);
        });

    return cmd;
}

async function handleRedmineCheck(options: CheckOptions): Promise<void> {
    const configService = new RedmineConfigService(options.config);
    const config = await configService.load();

    const result = await checkConnectivity(config);

    if (options.json) {
        console.log(JSON.stringify(result, null, 2));
    } else {
        if (result.success) {
            console.log('✅', result.message);
            if (result.details?.project) {
                console.log(
                    `   Project: ${result.details.project.name} (${result.details.project.identifier})`
                );
                console.log(`   Project ID: ${result.details.project.id}`);
            }
        } else {
            console.error('❌', result.message);
            process.exit(4);
        }
    }
}
